import React, { useRef } from 'react';
import DosingCalculator from './DosingCalculator';
import { useFocusTrap } from './hooks/useFocusTrap';

export default function DosingCalculatorModal({ onClose }) {
  const modalRef = useRef(null);

  useFocusTrap(modalRef, { onEscape: onClose });

  return (
    <div
      className="fixed inset-0 backdrop-blur-sm z-50 flex items-center justify-center p-6"
      onClick={onClose}
    >
      <div
        ref={modalRef}
        className="relative bg-pp-white dark:bg-zinc-900 rounded-xl shadow-2xl w-full max-w-xl border-4"
        style={{ borderColor: 'var(--accent-bg)' }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 text-2xl hover:scale-110 transition"
          style={{ color: 'var(--accent-text)' }}
        >
          &times;
        </button>
        <div className="px-6 py-4">
          <h2 className="text-xl font-bold mb-4" style={{ color: 'var(--accent-text)' }}>Dosing Calculator</h2>
          <DosingCalculator />
        </div>
      </div>
    </div>
  );
}
